import { LandingPage } from "@/components/home/landing-page";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { MetaTags } from "@/components/seo/meta-tags";
import { useAppContext } from "@/providers";
import { t } from "@/lib/i18n/messages";

export default function LandingPageRoute() {
  const { locale } = useAppContext();
  const pageTitle = `${t(locale, "home")} | NCircle`;
  useDocumentTitle(pageTitle);

  return (
    <>
      <MetaTags
        description={t(locale, "heroSubtitle")}
        ogTitle={pageTitle}
        ogDescription={t(locale, "heroSubtitle")}
        ogImage="/og-image.png"
        ogUrl="https://partner.ncircle.ai/"
        ogType="website"
      />
      <LandingPage />
    </>
  );
}
